export const LOAD_PREFERENCIAS = '@preferencias/LOAD';
export const UPDATE_PREFERENCIAS = '@preferencias/UPDATE';
export const RESET_PREFERENCIAS = '@preferencias/RESET';

export const PREFERENCIAS_STORAGE_KEY = 'preferencias';